import { useSelector } from 'react-redux';

import { getEventConfigs } from '@state/event';
import { canMockPrinting } from '~capacitor-plugins/BadgePrinter';
import { Capacitor } from '~capacitor-plugins/core';

// Check if the capacitor plugin is available, to avoid outdated onsite apps crashing
const isPluginAvailable = Capacitor.isPluginAvailable('BadgePrinter');
// Check if this is using iOS, since we’re not supporting Android or Web
const isSupported = Capacitor.getPlatform() === 'ios';

export const usePrintingEnabled = () => {
  const eventConfigs = useSelector(getEventConfigs);
  // Onsite Badge Printing config is enabled
  const isBadgePrintingEnabled = eventConfigs.badgePrintingOnsiteLabelsEnabled;
  // Onsite settings has a onsite_label_printing_badges configured
  const hasPrintableLabel = eventConfigs.onsiteLabelPrintingBadges.length > 0;

  return (
    isBadgePrintingEnabled &&
    hasPrintableLabel &&
    isPluginAvailable &&
    (isSupported || canMockPrinting)
  );
};
